export const gridConfig = {
  outerGutterWidths: [24],
  innerGutterWidths: [12, , 24],
  gridColumns: 12, // In future, might be nice to make this an array
  containerMaxWidths: [588, 768, 1008, 1188, 1248],
};
